export enum tipoParametro {
  Vetorial = 1,
  Escalar
}
